import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { FieldAttributes, getIn } from 'formik';
import React from 'react';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { ReactComponent as FieldErrorIcon } from '../../images/icons/field_error.svg';

interface TextInputFormFieldProps {
  field: { name: string; onBlur(): void; onChange(): void; value: string };
  form: FieldAttributes<any>;
  placeholder: string;
  extra: { children: any; label: string; margin: string; placeHolder: string };
}

export const TextInputFormField = (props: TextInputFormFieldProps) => {
  const { field, form, placeholder, ...extra } = props;
  const errorText = getIn(form.errors, field.name);

  return (
    <TextField
      fullWidth
      variant="outlined"
      helperText={
        errorText ? (
          <>
            {[].concat(errorText).map((text) => (
              <li style={{ listStyleType: 'none' }} key={text}>
                {text}
              </li>
            ))}
          </>
        ) : null
      }
      error={!!errorText}
      InputProps={{
        endAdornment: errorText ? (
          <InputAdornment position="end">
            <FieldErrorIcon />
          </InputAdornment>
        ) : undefined,
      }}
      {...extra}
      placeholder={placeholder}
      {...field}
    />
  );
};

interface IconAdornmentProps {
  onClick(): void;
  faIconProps: FontAwesomeIconProps;
  width?: string;
}

export const IconAdornment = (props: IconAdornmentProps) => {
  const { onClick, faIconProps, width } = props;

  return (
    <IconButton onClick={onClick}>
      <FontAwesomeIcon {...faIconProps} width={width} />
    </IconButton>
  );
};
